exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tableButton-ab184{display:inline-flex;justify-content:center;align-items:center;font-size:14px !important}", ""]);

// Exports
exports.locals = {
	"tableButton": "tableButton-ab184"
};